module.exports = __webpack_public_path__ + "img/bgTitle1.5e43a90f.png";